import { useQuery } from "@tanstack/react-query";
import Axios from "../../../Axios/Axios";
import { Urls } from "../../../Urls";

export const useTmsDashboardFilters = ({
  startDate,
  endDate,
  plant,
  destination,
  transporterId,
  role,
  screen,
}) => {
  return useQuery({
    queryKey: [
      "tmsDashboardFilters",
      startDate,
      endDate,
      plant,
      destination,
      transporterId,
      role,
      screen,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (startDate && endDate) {
        params.append("start_date", startDate);
        params.append("end_date", endDate);
      }
      if (plant && plant !== "All") params.append("plant", plant);
      if (destination && destination !== "All") params.append("destination", destination);
      if (transporterId && transporterId !== "All") params.append("transporter_id", transporterId);
      if (role) params.append("role", role);
      if (screen) params.append("screen", screen);
      const { data } = await Axios.get(`${Urls.tmsDashboardFilters}?${params.toString()}`);
      return data;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
